import axios from 'axios'

export type UtiliteitnetStatus = 'concept' | 'actief' | 'gearchiveerd'

export interface Utiliteitsnet {
  id: string
  naam: string
  beschrijving: string | null
  status: UtiliteitnetStatus
  createdAt: string
  updatedAt: string
}

export interface CreateUtiliteitnetDto {
  naam: string
  beschrijving?: string
  status?: UtiliteitnetStatus
}

export interface UpdateUtiliteitnetDto {
  naam?: string
  beschrijving?: string
  status?: UtiliteitnetStatus
}

export interface FilterUtiliteitnetDto {
  status?: UtiliteitnetStatus
  page?: number
  limit?: number
}

export interface PaginatedUtiliteitsnetten {
  total_rows: number
  total_pages: number
  page: number
  limit: number
  data: Utiliteitsnet[]
}

const BASE = '/api/grondwerk/netten'

export async function getUtiliteitsnetten(filter?: FilterUtiliteitnetDto): Promise<PaginatedUtiliteitsnetten> {
  const response = await axios.get(BASE, { params: filter })
  return response.data
}

export async function getUtiliteitsnet(id: string): Promise<Utiliteitsnet> {
  const response = await axios.get(`${BASE}/${id}`)
  return response.data
}

export async function createUtiliteitsnet(dto: CreateUtiliteitnetDto): Promise<Utiliteitsnet> {
  const response = await axios.post(BASE, dto)
  return response.data
}

export async function updateUtiliteitsnet(id: string, dto: UpdateUtiliteitnetDto): Promise<Utiliteitsnet> {
  const response = await axios.patch(`${BASE}/${id}`, dto)
  return response.data
}

export async function deleteUtiliteitsnet(id: string): Promise<void> {
  await axios.delete(`${BASE}/${id}`)
}
